import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './Components/Header';
import Footer from './Components/Footer';
import Home from './Components/Home';
import Contact from './Components/Contact'
import About from './About';
import RefundPolicy from './Components/RefundPolicy';
import PrivacyPolicy from './Components/PrivacyPolicy';
import TermsAndConditions from './Components/TermsAndConditions';
import EcoFarming from './Components/EcoFarming'
// This is the wrapper that handles routes and layout
function AppWrapper() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <>
      <Header />

      {isHomePage && <Home />}

      <Routes>
        <Route path="/home" element={<Home />} />
        <Route path='/contact' element={<Contact/>} />
        <Route path='/about' element={<About/>} />
       <Route path='/refundpolicy' element={<RefundPolicy/>} />
<Route path='/privacypolicy' element={<PrivacyPolicy/>}/>
<Route path='/termsandconditions' element={<TermsAndConditions/>}/>
<Route path='/EcoFarming' element={<EcoFarming/>} />
      </Routes>

      <Footer />
    </>
  );
}

// App component
function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}

export default App;
